import PropTypes from 'prop-types'
import React from 'react'
import {Collapse} from "antd";
import moment from 'moment'

import {formatDateTime} from "../../utils";

export const EventDetail = ({event}) => (
    <React.Fragment>
        <div className="ui segment">
            <h1 className="ui header">{event.title}</h1>
            <div className="ui divider"/>
            <h3 className="ui header">About</h3>
            <div dangerouslySetInnerHTML={{__html: event.description}}/>
            <div className="ui divider"/>
        </div>
        {event.addon_description && (
            <div className="ui segment">
                <h3 className="ui header">{event.title}</h3>
                <div dangerouslySetInnerHTML={{__html: event.addon_description}}/>
                {event.addon_images.map(image => (
                    <img style={{marginTop: '10px'}} src={image.image}/>
                ))}
            </div>
        )}
        <div className="ui segment">
            <h1>คำถามที่พบบ่อย?</h1>
            <Collapse bordered={false} defaultActiveKey={['0']}>
                <Collapse.Panel header="จะได้รับของเมื่อไร" key="1">
                    <p>
        <span>
            Run24Hrs จะจัดส่งเสื้อภายในช่วงวันที่ {formatDateTime(event.ship_date)} - {formatDateTime(moment(event.ship_date).add(7, 'day'))} โดยจัดส่งแบบลงทะเบียนโดยไปรษณีย์ไทย
        </span>
                    </p>
                </Collapse.Panel>
            </Collapse>
        </div>
    </React.Fragment>
)

EventDetail.propTypes = {
    addons: PropTypes.arrayOf(PropTypes.object),
    race: PropTypes.object,
    racesDetail: PropTypes.arrayOf(PropTypes.object)
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/EventDetail/index.js